import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[fileUploadPreview]'
})
export class FileUploadPreviewDirective implements OnChanges {
  @Input() public media:File;

  constructor(
    private elementRef:ElementRef
  ) {
    /**/
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.media) {
      if (this.media.type.startsWith('image')) {
        this.elementRef.nativeElement.src = URL.createObjectURL(this.media);
      }
    }
  }
}